var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var MAP_ZOOM = 12;
var COORDINATE = /^([NSEW])(\d{1,3}(?:\.\d+)?)$/;
/**
 * Converts `E000.0088` / `S084.7061` to signed decimal degrees. Returns `null` for anything
 * else — a malformed or DMS-shaped value yields no link rather than a link to the wrong place.
 * Latitude accepts only N/S up to 90, longitude only E/W up to 180.
 */
export var parseHemisphereDegrees = function (value, axis) {
    var match = COORDINATE.exec((value !== null && value !== void 0 ? value : '').trim());
    if (!match)
        return null;
    var hemisphere = match[1], digits = match[2];
    var allowed = axis === 'latitude' ? 'NS' : 'EW';
    if (!allowed.includes(hemisphere))
        return null;
    var degrees = Number(digits);
    if (degrees > (axis === 'latitude' ? 90 : 180))
        return null;
    // `0 * -1` is -0, which would print as "0" but compare unequal under Object.is.
    if (degrees === 0)
        return 0;
    return hemisphere === 'S' || hemisphere === 'W' ? -degrees : degrees;
};
var subfieldValue = function (field, code) { var _a; return (_a = field.subfields.find(function (sf) { return sf.subfieldCode === code; })) === null || _a === void 0 ? void 0 : _a.value; };
/**
 * One axis of a `034` field: the midpoint of its two edges. An ABSENT edge falls back to the
 * other one, so a field stating only `$d` and `$f` is still a point; a PRESENT but unreadable
 * edge voids the axis — falling back there would link to one edge of a box as if it were the
 * whole place.
 */
var axisMidpoint = function (field, codes, axis) {
    var edges = codes
        .map(function (code) { return subfieldValue(field, code); })
        .filter(function (value) { return value !== undefined; })
        .map(function (value) { return parseHemisphereDegrees(value, axis); });
    if (edges.length === 0 || edges.some(function (edge) { return edge === null; }))
        return null;
    var _a = edges, first = _a[0], _b = _a[1], second = _b === void 0 ? first : _b;
    return (first + second) / 2;
};
/**
 * The location one `034` field describes: the point itself, or the centre of a bounding box
 * (`$d`/`$e` west/east longitude, `$f`/`$g` north/south latitude).
 */
export var locationFrom034 = function (field) {
    var longitude = axisMidpoint(field, ['d', 'e'], 'longitude');
    var latitude = axisMidpoint(field, ['f', 'g'], 'latitude');
    if (latitude === null || longitude === null)
        return null;
    return { latitude: latitude, longitude: longitude };
};
var format = function (degrees) { return String(Number(degrees.toFixed(6))); };
export var mapyCzUrl = function (_a) {
    var latitude = _a.latitude, longitude = _a.longitude;
    return "https://mapy.cz/fnc/v1/showmap?mapset=basic&center=".concat(format(longitude), ",").concat(format(latitude))
        + "&zoom=".concat(MAP_ZOOM, "&marker=true");
};
export var googleMapsUrl = function (_a) {
    var latitude = _a.latitude, longitude = _a.longitude;
    return "https://www.google.com/maps/search/?api=1&query=".concat(format(latitude), ",").concat(format(longitude));
};
/** One link pair per distinct location in the record's `034` fields; empty without `034`. */
export var mapLinksFromDataFields = function (dataFields) {
    var seen = new Set();
    var links = [];
    (dataFields !== null && dataFields !== void 0 ? dataFields : [])
        .filter(function (field) { return field.fieldTag === '034'; })
        .forEach(function (field) {
        var location = locationFrom034(field);
        if (!location)
            return;
        var key = "".concat(format(location.latitude), ",").concat(format(location.longitude));
        if (seen.has(key))
            return;
        seen.add(key);
        links.push(__assign(__assign({}, location), { label: key.replace(',', ', '), mapyCz: mapyCzUrl(location), googleMaps: googleMapsUrl(location) }));
    });
    return links;
};
